import { __assign, __rest } from "tslib";
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglassHalf } from '@fortawesome/pro-light-svg-icons';
var element = React.createElement(FontAwesomeIcon, { className: "buttonIcon", icon: faHourglassHalf });
export var AsureCloudButton = function (_a) {
    var state = _a.state, icon = _a.icon, text = _a.text, loading = _a.loading, className = _a.className, props = __rest(_a, ["state", "icon", "text", "loading", "className"]);
    var classList = '';
    classList += " btn-" + state;
    classList += icon === 'left' ? ' flex-row' : ' flex-row-reverse';
    classList += !props.disabled ? '' : ' disabled';
    classList += loading ? ' loading' : '';
    return (React.createElement("button", __assign({ className: "cloud btn d-flex justify-content-between align-items-center " + className + " " + classList }, props),
        loading && element,
        text));
};
export default AsureCloudButton;
//# sourceMappingURL=Button.js.map